// extracted by mini-css-extract-plugin
export default {"title":"infosection_title__Eh-cg","list":"infosection_list__01dGD","item":"infosection_item__pYvOY"};